var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class SageApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'sage';
    }
    getCustomers(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params: { id },
            });
        });
    }
    createCustomer(customerData) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data: customerData,
            });
        });
    }
    updateCustomer(id, customerData) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${id}`,
                data: customerData,
            });
        });
    }
    deleteCustomer(id, softDelete) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}/${id}`,
                params: { softDelete },
            });
        });
    }
    getJournalEntryStatuses(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/journal-entry-status`, params }, options));
        });
    }
    setupManualMonthlyBilling(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/manual-monthly-billing`, data: params }, options));
        });
    }
    createMonthlyBillingJournalEntry(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/monthly-billing-journal-entry`, data: params }, options));
        });
    }
}
//# sourceMappingURL=index.js.map